export const MAT_PAGINATOR_CLASS = '.mat-paginator-container';
